import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  useTheme
} from "@mui/material";
import {
  SecurityOutlined,
  LightModeOutlined,
  DarkModeOutlined,
  PersonOutlined
} from "@mui/icons-material";
import { useContext, useState } from "react";
import { ColorModeContext, tokens } from "../../../theme";
import { useDiscreteMode } from "./DiscreteMode";
import useAuth from "../../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { useSendLogoutMutation } from "../../../features/auth/authApiSlice";

const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const { username } = useAuth();
  const { toggleDiscreteMode } = useDiscreteMode();
  const navigate = useNavigate();

  /* ----- logout mutation ----- */
  const [sendLogout] = useSendLogoutMutation();

  /* ----- menu state ----- */
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleProfile = () => {
    handleMenuClose();
    navigate(`/console/users/${username}`);
  };

  const handleLogout = async () => {
    handleMenuClose();
    try {
      await sendLogout().unwrap();
    } catch (err) {
      console.error("Logout failed:", err);
    }
    navigate("/"); // back to landing page
  };

  return (
    <Box display="flex" justifyContent="space-between" p={4}>
      {/* SEARCH BAR placeholder */}
      <Box
        display="flex"
        backgroundColor={colors.primary[400]}
        borderRadius="3px"
      ></Box>

      {/* ACTION ICONS */}
      <Box display="flex">
        <IconButton onClick={toggleDiscreteMode}>
          <SecurityOutlined />
        </IconButton>

        <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "dark" ? (
            <LightModeOutlined />
          ) : (
            <DarkModeOutlined />
          )}
        </IconButton>

        {/* USER MENU */}
        <IconButton onClick={handleMenuOpen}>
          <PersonOutlined />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MenuItem onClick={handleProfile}>Profile</MenuItem>
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </Box>
    </Box>
  );
};

export default Topbar;
